<template>
  <transition name="fade">
    <div class="error" v-show="errors.length ? true : false">
      <ul>
        <li v-for="(error, $index) in errors" :key="$index">{{ error }}</li>
      </ul>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'error',
  props: {
    errors: {
      type: [String, Array],
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.error {
  color: #fff;
  background: #fa6161;
  padding: 15px 20px;
  width: 100%;
  border-radius: 5px;
}
.error ul {
  margin-bottom: 0;
  padding-left: 20px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

</style>
